"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddNodeModal = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const formik_1 = require("formik");
const react_redux_1 = require("react-redux");
const add_node_modal_utils_1 = require("./add-node-modal.utils");
const partials_1 = require("../partials");
const use_tree_node_validation_schema_hook_1 = require("./hooks/use-tree-node-validation-schema.hook");
const use_highlight_created_node_hook_1 = require("../../hooks/use-highlight-created-node.hook");
const use_tree_node_filtering_hook_1 = require("../../hooks/use-tree-node-filtering.hook");
const attributes_1 = require("../../../../client/attributes");
const hooks_1 = require("../../../../client/hooks");
const add_product_tree_node_hook_1 = require("../../../../client/product-tree-node/hooks/add-product-tree-node.hook");
const product_tree_nodes_1 = require("../../../../client/product-tree-nodes");
const table_filter_1 = require("../../../../common/table-filter");
const components_1 = require("../../../../components");
const hooks_2 = require("../../../../hooks");
const actions_1 = require("../../../../store/catalogs/actions");
const hooks_3 = require("../../../../../hooks");
const localization_1 = require("../../../../../localization");
const store_1 = require("../../../../../store");
// eslint-disable-next-line complexity
const AddNodeModal = ({ open, onClose, treeNodeParentToAddTo, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const productTreeId = (0, store_1.useProductTreeId)();
    const { addSuccess } = (0, hooks_3.useNotification)();
    const { refetchProductTreeNodes } = (0, hooks_1.useRefetchQueries)();
    const { highlightNode } = (0, use_highlight_created_node_hook_1.useNodeHighlightContext)();
    const { addToExtendedFilter, hasExtendedFilterApplied } = (0, use_tree_node_filtering_hook_1.useTreeNodeFiltering)();
    const { id, title, isTerminalNode: isParentNodeTerminal, isRootNode, totalProductsCount, path, } = treeNodeParentToAddTo !== null && treeNodeParentToAddTo !== void 0 ? treeNodeParentToAddTo : {};
    const doesParentNodeHaveProducts = totalProductsCount > 0;
    const selectedTreeNodeIds = (0, react_1.useMemo)(() => (0, product_tree_nodes_1.getTreeNodeIdsFromPath)(path), [path]);
    const { addProductTreeNode, loading: isAddingNode, error: addNodeError, } = (0, add_product_tree_node_hook_1.useAddProductTreeNode)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const selectedCatalogId = (0, store_1.useSelectedCatalogId)();
    const { reclassify } = (0, hooks_2.useReclassify)({ selectedTreeNodePath: path });
    const validationSchema = (0, use_tree_node_validation_schema_hook_1.useTreeNodeValidationSchema)();
    const formik = (0, formik_1.useFormik)({
        initialValues: add_node_modal_utils_1.initialValues,
        validateOnBlur: true,
        validateOnChange: false,
        validationSchema,
        onSubmit: (values) => {
            void addProductTreeNode({
                variables: {
                    productTreeNode: {
                        clientMutationId: '',
                        productTreeId,
                        parentNodeId: id,
                        data: {
                            title: values.nodeName,
                            description: values.guidelines,
                            // those values are deprecated, but backend still expects them
                            filters: [],
                            validators: [],
                        },
                    },
                },
                onCompleted: (data) => __awaiter(void 0, void 0, void 0, function* () {
                    var _a;
                    const newNode = (_a = data === null || data === void 0 ? void 0 : data.addProductTreeNode) === null || _a === void 0 ? void 0 : _a.productTreeNode;
                    try {
                        if (isParentNodeTerminal && doesParentNodeHaveProducts) {
                            yield reclassify({
                                filter: {
                                    product: {
                                        attributes: [(0, table_filter_1.createProductCategoryFilter)({ search: title, match: ui_components_1.MatchOptions.Include })],
                                    },
                                },
                                targetCategory: attributes_1.UN_CATEGORIZED_NODE_TITLE,
                            });
                            // For reclassify case, apply force-visible immediately since we can't wait for completion
                            if (newNode && typeof newNode.id === 'string' && selectedCatalogId) {
                                dispatch((0, actions_1.addToExclusiveFilterForProductTreeTaxonomy)(selectedCatalogId, newNode.id));
                            }
                        }
                        else {
                            // Wait for the refetch to complete before making the node force-visible
                            yield refetchProductTreeNodes(selectedTreeNodeIds);
                            // Now that refetch is complete, apply the force-visible logic
                            if (newNode && typeof newNode.id === 'string' && selectedCatalogId) {
                                dispatch((0, actions_1.addToExclusiveFilterForProductTreeTaxonomy)(selectedCatalogId, newNode.id));
                            }
                        }
                        // Handle selection logic for both cases
                        if (newNode && typeof newNode.id === 'string' && selectedCatalogId) {
                            // Only add to extended filter if we're currently in filtering mode
                            if (hasExtendedFilterApplied) {
                                addToExtendedFilter(newNode.id);
                            }
                            highlightNode(newNode.id);
                        }
                        addSuccess(t({ key: 'ADD_NODE_SUCCESS' }));
                        onClose({}, 'escapeKeyDown');
                        formik.resetForm();
                    }
                    catch (e) {
                        // Errors are surfaced via hooks; keep dialog open for retry
                        console.error(e);
                    }
                }),
            });
        },
    });
    const { values, errors, touched, handleChange, handleBlur, isSubmitting, } = formik;
    const handleModalClose = (event, reason) => {
        onClose(event, reason);
        formik.resetForm();
    };
    return (react_1.default.createElement(partials_1.StyledTreeActionsDialog, { open: open, onClose: handleModalClose, title: t({ key: 'ADD_NODE' }), proceedButtonProps: {
            title: t({ key: 'ADD_ENTITY', values: { entity: '' } }),
            onClick: () => {
                void formik.submitForm();
            },
            disabled: !formik.isValid || !formik.dirty,
            loading: isAddingNode || isSubmitting,
        }, cancelButtonProps: {
            title: t({ key: 'CANCEL' }),
            onClick: () => handleModalClose({}, 'escapeKeyDown'),
            disabled: isAddingNode,
        } }, !isRootNode && (react_1.default.createElement(material_1.TextField, { name: "parentNode", label: t({ key: 'PARENT_NODE' }), value: title, InputProps: { readOnly: true }, disabled: true, fullWidth: true, variant: "outlined" })), react_1.default.createElement(material_1.TextField, { name: "nodeName", label: isRootNode
            ? t({ key: 'NODE_NAME' })
            : t({ key: 'CHILD_NODE' }), fullWidth: true, variant: "outlined", disabled: isAddingNode, value: values.nodeName, onChange: handleChange, onBlur: handleBlur, error: Boolean(touched.nodeName && errors.nodeName), helperText: touched.nodeName && errors.nodeName }), !isRootNode && (react_1.default.createElement(material_1.TextField, { name: "guidelines", label: `${t({ key: 'GUIDELINES' })} (${t({ key: 'OPTIONAL' })})`, multiline: true, rows: 4, fullWidth: true, variant: "outlined", disabled: isAddingNode, value: values.guidelines, onChange: handleChange, onBlur: handleBlur, error: Boolean(touched.guidelines && errors.guidelines), helperText: touched.guidelines && errors.guidelines })), isParentNodeTerminal && doesParentNodeHaveProducts && (react_1.default.createElement(components_1.Alert, { severity: 'warning' }, react_1.default.createElement(material_1.AlertTitle, null, t({ key: 'WARNING' })), t({ key: 'ADD_NODE_TERMINAL_WARNING', values: { nodeName: title } }))), addNodeError && (react_1.default.createElement(components_1.Alert, { severity: "error" }, t({ key: 'CATALOG_STATE_ERROR' })))));
};
exports.AddNodeModal = AddNodeModal;
